import React from "react";
import Layout from "../components/Layout";
import MesTaches from "../components/Employé/MesTaches";

function MesTache() {
  
  return (
    <Layout >
      <div className="p-6">
        <MesTaches />
      </div>
    </Layout>
  );
}

export default MesTache;
